/**
 * Build a Google Maps Embed URL from a safe public address only.
 * Never include tokens, campaign/mailing/property IDs, or form PII.
 *
 * Env: VITE_GOOGLE_MAPS_EMBED_API_KEY
 * Restrict the browser key HTTP referrers to:
 * - https://staging.rentalyzer.ca/*
 * - https://rentalyzer.ca/*
 * - an explicitly limited local-development origin if required
 * Do not use rentalyzer.dmii.ca.
 */
import { publicProspectPageConfig } from '../../config/publicProspectPageConfig.js';

const SAFE_ADDRESS_KEYS = Object.freeze(['address', 'city', 'province', 'postalCode']);

/** Fixed Embed zoom — never accept from URL/query/campaign/property/user input. */
export const PUBLIC_PROSPECT_MAP_ZOOM = publicProspectPageConfig.map.zoom;

export function formatPublicProspectAddress(property) {
  if (!property || typeof property !== 'object' || Array.isArray(property)) return '';
  return SAFE_ADDRESS_KEYS.map((key) => property[key])
    .filter((part) => typeof part === 'string' && part.trim())
    .map((part) => part.trim())
    .join(', ');
}

export function buildPublicProspectMapEmbedUrl(property, apiKey = import.meta.env.VITE_GOOGLE_MAPS_EMBED_API_KEY) {
  const key = typeof apiKey === 'string' ? apiKey.trim() : '';
  const address = formatPublicProspectAddress(property);
  if (!key || !address) return null;
  // Strict construction: only allowlisted address fields + fixed map options + key.
  const params = new URLSearchParams();
  params.set('key', key);
  params.set('q', address);
  params.set('maptype', 'satellite');
  params.set('zoom', String(PUBLIC_PROSPECT_MAP_ZOOM));
  return `https://www.google.com/maps/embed/v1/place?${params.toString()}`;
}
